import { render, staticRenderFns } from "./ChatGroupedMessage.vue?vue&type=template&id=e0c06c50&scoped=true&lang=pug"
import script from "./ChatGroupedMessage.vue?vue&type=script&lang=js"
export * from "./ChatGroupedMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupedMessage.vue?vue&type=style&index=0&id=e0c06c50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c06c50",
  null
  
)

export default component.exports